import React, { PropTypes } from 'react';

const Loading = ({ qaSelector, className, accessibleText, ariaHidden = false }) =>
	<span
		data-qa={qaSelector}
		className={className}
		aria-hidden={ariaHidden}>
		<span
			className="dna-invisible">
			{ accessibleText }
		</span>
	</span>;

Loading.propTypes = {
	qaSelector: PropTypes.string,
	className: PropTypes.string.isRequired,
	accessibleText: PropTypes.string.isRequired,
	ariaHidden: PropTypes.bool.isRequired
};

export default Loading;



// WEBPACK FOOTER //
// ../~/dna-core/components/utils/elements/Loading.jsx